import { ImageLoaderProps } from 'next/image';

function defaultLoader({ src }: ImageLoaderProps) {
  // Check if the URL is from images.ctfassets.net
  if (src.includes('images.ctfassets.net')) {
    const [baseUrl, ...queryParts] = src.split('?');
    const queryString = queryParts.join('&');
    const parameters = new URLSearchParams(queryString);

    // Append fm=webp to the URL, handling existing query parameters
    parameters.set('fm', 'webp');

    // Handle suffix for images.ctfassets.net
    const suffix = parameters.get('suffix');
    if (suffix) {
      const lastDotIndex = baseUrl.lastIndexOf('.');
      return `${baseUrl.substring(0, lastDotIndex)}-${suffix}.${baseUrl.substring(
        lastDotIndex + 1,
      )}?${parameters.toString()}`;
    }

    return `${baseUrl}?${parameters.toString()}`;
  }

  // Image source with the query parameters removed
  const [source, query] = src.split('?');
  const queries = new URLSearchParams(query || ''); // Handle undefined query
  const suffix = queries.get('suffix'); // Image variants: small, medium, large, etc...

  // Add suffix if exists
  if (suffix) {
    const lastDotIndex = source.lastIndexOf('.');
    return `${source.substring(0, lastDotIndex)}-${suffix}.${source.substring(lastDotIndex + 1)}`;
  }

  return source;
}

export default defaultLoader;
